<template>
	<div class="container">
		<!--页面开始-->
		<div class="main_box">
			<div class="product_box">
				<div v-for="(value, index) in productList" class="pro_el" @click="checkDom(value)">
					<div class="one">
						<img v-if="value.id == nowId.id" src="../../assets/img/icon_checked.png" />
						<img v-else src="../../assets/img/icon_nocheck.png" />
					</div>
					<div class="two">
						<div class="two_tit">{{ value.title }}</div>
						<!-- <div class="two_txt">用时{{ value.time }}分钟</div> -->
					</div>
					<div class="three">
						<img :src="value.url" />
					</div>
				</div>
			</div>
			<div class="bottom_btn">
				<van-button
					type="info"
					block
					@click="onSubmit"
					color="#4f56fe"
				>
					确定
				</van-button>
			</div>
		</div>
		<!--页面开始-->
	    <!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { productList } from "@/api/public";
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,
			nowId: [],  //当前选中id
			productList: [],  //产品列表
		}
	},
	created(){
		//
	},
	mounted() {
		let that = this;
		//请求产品列表
		productList().then(res => {
			that.productList = res.data;
			//微信分享
			that.$nextTick(() => {
				shareUrl(that);
			});
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//选中选项
		checkDom(value) {
			let that = this;
			if(value.id == that.nowId.id) {
				that.nowId = [];
			}else {
				that.nowId = value;
			}
		},
		//确定
		onSubmit() {
			let that = this;
			if(that.nowId.id) {
				//进入下一步
				sessionStorage.setItem('productId', that.nowId.id);
				if(that.$route.query.type == 1) {
					//检测
					that.$router.push({path: that.nowId.test});
				}else if(that.$route.query.type == 2) {
					//拍照
					that.$router.push({path: that.nowId.upload});
				}
			}else {
				that.$toast('请先选择产品');
			}
		},
	},
	beforeDestroy() {
		//
	}
}
</script>
</script>

<style scoped>
.main_box{
	position: relative;
	width: 100%;
	min-height: 100vh;
	height: 100%;
	padding: 0.48rem;
	background-color: #F7F7F9;
	padding-bottom: 3rem;
}
.pro_el{
	display: flex;
	align-items: center;
	padding: 0.67rem 0.42rem;
	margin-bottom: 0.64rem;
	background-color: #ffffff;
	border-radius: 2px;
}
.pro_el .one{
	width: 0.32rem;
	height: 0.32rem;
}
.pro_el .one img{
	width: 0.32rem;
	height: 0.32rem;
}
.pro_el .two{
	flex: 1;
	padding-left: 0.84rem;
}
.pro_el .two .two_tit{
	font-size: 0.45rem;
	font-weight: bold;
	color: #333333;
}
.pro_el .two .two_txt{
	position: relative;
	top: 0.12rem;
	font-size: 0.32rem;
	color: #666666;
}
.pro_el .three{
	
}
.pro_el .three img{
	width: 3.34rem;
	height: auto;
}

.bottom_btn{
	position: fixed;
	width: 100%;
	left: 0;
	padding: 1.2rem 1rem;
	bottom: 0;
}
</style>
